export function isNil(val: unknown) {
  if (typeof val === 'undefined' || val === 'null' || val === '') return true
}

export function getEntries<Key extends string | number | symbol, Value>(
  obj: Record<Key, Value>
): [Key, Value][] {
  return Object.entries(obj) as [Key, Value][]
}

export function getValues<Key extends string | number | symbol, Value>(
  obj: Record<Key, Value>
): Value[] {
  return Object.values(obj)
}

export function getKeys<Key extends string | number | symbol, Value>(
  obj: Record<Key, Value>
): Key[] {
  return Object.keys(obj) as Key[]
}
